import { Injectable } from '@angular/core';
import { ShepherdService } from 'angular-shepherd';
import { offset } from '@floating-ui/dom';

import { OnboardingService } from './onboarding.service';

import type Step from 'shepherd.js/src/types/step';
import {
  AppTypeCodesWithHash,
  OnboardingStatus,
} from '../interfaces/onboarding.interface';

const DEFAULT_OPTIONS = {
  scrollTo: false,
  cancelIcon: {
    enabled: true,
  },
  canClickTarget: true,
  modalOverlayOpeningPadding: 20,
  modalOverlayOpeningRadius: 40,
  classes: 'guide-tour-block',
  floatingUIOptions: {
    middleware: [offset(50)],
  },
  confirmCancel: true,
};

export const GUIDE_BUTTONS = {
  back: {
    classes: 'guide-tour-btn guide-tour-btn-back',
    text: 'Назад',
    type: 'back',
  },
  next: {
    classes: 'guide-tour-btn guide-tour-btn-next',
    text: 'Дальше',
    type: 'next',
  },
};

@Injectable()
export class GuideTourService {
  defaultStepOptions = DEFAULT_OPTIONS;

  constructor(
    private shepherdService: ShepherdService,
    private onboardingService: OnboardingService
  ) {}

  onCompleteAndCancelFn(statusNumber: OnboardingStatus): void {
    const pathname = window.location.pathname as keyof typeof AppTypeCodesWithHash;
    const appTypeCode = AppTypeCodesWithHash[pathname];

    this.onboardingService
      .setOnboardingStatus({
        appTypeCode,
        isOnboarding: statusNumber,
      })
      .subscribe();
  }

  setStepOptions(options: any): void {
    this.defaultStepOptions = options;
  }

  startGuide(steps: Step[]): void {
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    this.shepherdService.modal = true;
    this.shepherdService.confirmCancel = false;
    this.shepherdService.addSteps(steps);
    this.shepherdService.start();

    this.shepherdService.tourObject.on('cancel', () =>
      this.onCompleteAndCancelFn(0)
    );
    this.shepherdService.tourObject.on('complete', () =>
      this.onCompleteAndCancelFn(1)
    );
  }

  cancelGuide(): void {
    this.shepherdService.cancel();
  }
}
